import { useQuery } from '@tanstack/react-query';

import getDraftGiveawaySession from 'Api/productivity-host/getDraftGiveawaySession';
import getDraftGiveawaySessionResponse from './model/response/getDraftGiveawaySessionResponse';

const useGetDraftGiveawaySession = ({ isOpen, sessionId }) => {
  return useQuery({
    queryKey: ['draft-giveaway-session', sessionId],
    queryFn: async () => {
      const response = await getDraftGiveawaySession(sessionId);

      return getDraftGiveawaySessionResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: isOpen && !!sessionId,
  });
};

export default useGetDraftGiveawaySession;
